'use client';

import { useEffect } from 'react';

import { useRouter } from 'next/navigation';

import { setFocus } from '@noriginmedia/norigin-spatial-navigation';

import Button from '@/components/Button';
import { useGlobalConfig } from '@/components/GlobalContext';
import CustomTypography from '@/components/Typography/CustomTypography';

import { getLocalization } from '@/utils/localization';

const NOT_FOUND_CTA_FOCUS_KEY = 'not-found-cta';

export default function NotFoundError() {
  const { userLanguage } = useGlobalConfig();
  const router = useRouter();

  useEffect(() => {
    setFocus(NOT_FOUND_CTA_FOCUS_KEY);
  }, []);

  return (
    <div className="flex flex-col w-screen h-screen bg-black justify-center items-center">
      <div className="w-[50rem] text-center items-center flex flex-col justify-center">
        <div>
          <CustomTypography
            variant="10ftLargeTitle"
            styleClasses="line-clamp-2 !text-componentEmphasized"
          >
            {getLocalization(userLanguage)['errors']['not-found-2023']['error-code']}
          </CustomTypography>
          <CustomTypography
            variant="10ftTitle1"
            styleClasses="line-clamp-2 !text-componentEmphasized"
          >
            {getLocalization(userLanguage)['errors']['not-found-2023']['error-title']}
          </CustomTypography>
          <CustomTypography
            variant="10ftBody"
            styleClasses="line-clamp-2 !text-componentEmphasized"
          >
            {getLocalization(userLanguage)['errors']['not-found-2023']['error-message']}
          </CustomTypography>
        </div>
        <Button
          className="flex group mt-16"
          focusKey={NOT_FOUND_CTA_FOCUS_KEY}
          onClick={() =>
            window.history.length > 1 ? router.back() : router.replace('/')
          }
          size="long"
        >
          {getLocalization(userLanguage)['errors']['not-found-2023']['error-button']}
        </Button>
      </div>
    </div>
  );
}
